import { fromJS } from "immutable";

export const GET_APPS_SUCCESS = "GET_APPS_SUCCESS";

const initialData = fromJS({
  appsList: null,
  minVersion: null,
});

export default (state = initialData, action) => {
  switch (action.type) {
    case GET_APPS_SUCCESS:
      return state.merge({
        appsList: action.payload.apps,
        minVersion: action.payload.minVersion,
      });
    default:
      return state;
  }
};
